var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,{tag:"component",attrs:{"product":_vm.viewData.product,"productData":_vm.productData,"loadingStatus":_vm.loadingStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }